import PropTypes from 'prop-types';
import React from 'react';
import LineItemStatus from 'lineItemStatus';
import InputCell from 'components/LineItemTable/inputCell';
import ItemNote from 'components/LineItemTable/itemNote';
import ItemEvents from 'components/LineItemTable/itemEvents';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import { urls } from 'helpers/url';
import phaseMerchandiseItem from 'types/phaseMerchandiseItem';
import { CONTRACT_VERIFICATION_STATUS_COLORS,
         MERCHANDISE_VERIFICATION_STATUSES,
         NON_LHI_SOURCES } from 'config/constants';
import S from 'styles/table.scss';
import Editable from 'mixins/editable';

class MerchandiseTableRow extends Editable(React.Component) {
  state = { ...this.props.lineItem };

  handleChange = attr => (val) => {
    let value = val.target ? val.target.value : val;
    if (attr === 'status') value = val.status;
    this.setState({ [attr]: value });
  }

  handleItemNumberChange = this.handleChange('item_number');
  handleModelNumberChange = this.handleChange('model_number');
  handleItemNameChange = this.handleChange('item_name');
  handleQuantityChange = this.handleChange('quantity');
  handleStockChange = this.handleChange('stock');
  handleNoteChange = this.handleChange('note');
  handleDeliveryTypeChange = this.handleChange('delivery_type');
  handleStatusChange = this.handleChange('status');

  handleSave = () => this.props.onSave(this.state);

  handleDelete = () => this.props.onDelete(this.state.id);

  renderStatusCell = () => {
    const lineItem = this.state;
    const { onSave, readOnly } = this.props;
    const options = MERCHANDISE_VERIFICATION_STATUSES;
    const onChange = this.context.isEditable ? this.handleStatusChange : onSave;
    const val = readOnly ? lineItem.status : (<LineItemStatus
      onChange={onChange} lineItem={lineItem} options={options}
    />);
    return (<EditableTableCell onChange={onChange} label="Status" value={val} className={S.largeColumn} >
      {val}
    </EditableTableCell>);
  }

  render = () => {
    const { isEditable } = this.context;
    const lineItem = this.state;
    const style = { background: CONTRACT_VERIFICATION_STATUS_COLORS[lineItem.status] };
    const itemNumber = lineItem.item_number;
    const itemNumberLink = NON_LHI_SOURCES.includes(this.props.phaseSource) ? itemNumber :
      (<a href={urls.lowesItem(itemNumber)} target="_blank" rel="noopener noreferrer">{itemNumber}</a>);
    const rowProps =
      { isNew: lineItem.id < 0, style, onSave: this.handleSave, onDelete: this.handleDelete };
    return (<EditableTableRow key={lineItem.id} id={lineItem.id} {...rowProps}>
      <ItemEvents
        display={!isEditable}
        label=""
        itemType="phaseMerchandiseItems"
        lineItem={lineItem}
        dataKeys={['status', 'item_number', 'model_number', 'item_name', 'stock', 'quantity', 'delivery_type', 'note']}
      />
      {this.renderStatusCell()}
      <InputCell attr="item_number" label="Item Number" lineItem={lineItem} onChange={this.handleItemNumberChange} cellValue={itemNumberLink} />
      <InputCell attr="model_number" label="Model Number" lineItem={lineItem} onChange={this.handleModelNumberChange} />
      <InputCell attr="item_name" label="Item Name" lineItem={lineItem} onChange={this.handleItemNameChange} />
      <InputCell attr="stock" label="Stock" lineItem={lineItem} onChange={this.handleStockChange} />
      <InputCell attr="quantity" label="QTY" lineItem={lineItem} onChange={this.handleQuantityChange} />
      <InputCell attr="delivery_type" label="Delivery Type" lineItem={lineItem} onChange={this.handleDeliveryTypeChange} />
      <ItemNote display label="Note" onChange={this.handleNoteChange} note={lineItem.note} id={lineItem.id} kind="merch" />
    </EditableTableRow>);
  }
}

MerchandiseTableRow.contextTypes = { isEditable: PropTypes.bool };

MerchandiseTableRow.propTypes = {
  lineItem: PropTypes.shape(phaseMerchandiseItem),
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  readOnly: PropTypes.bool,
  phaseSource: PropTypes.string,
};

MerchandiseTableRow.defaultProps = { lineItem: {} };

export default MerchandiseTableRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/components/merchandiseTableRow.jsx